import { Pipe, PipeTransform } from '@angular/core';
import { IAirPortTranslated } from '../../components/popular-airlines/models/airlineInfo.models';

@Pipe({
  name: 'limitTo',
})
export class LimitToPipe implements PipeTransform {
  transform(value: any[], args: number): IAirPortTranslated[] {
    if (!value || !args) {
      return value;
    } else {
      if (value.length > args) {
        return value.slice(0, args);
      } else {
        return value;
      }
    }
  }
}
